import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import TagManagerService from "services/TagManager";
import Search from "components/Header/Search";
import LoginService from 'services/Login/';
import useVariant from 'hooks/useVariant';
import { searchVariantID,  frequentProductsID, primeInvitation, primeFlag} from 'config';
import {header, ecommerce, actionsType} from 'config/constants';
import StorageService from 'services/StorageService/';
import PubSub from 'services/PubSub/';
import MobileMenu from 'components/Header/MobileMenu';
import UserMenu from 'components/Header/Content/UserMenu';
import DeliverySelector from 'components/Header/DeliverySelector'
import Notifications from './Notifications';
import LoginRegister from 'components/Header/LoginRegister';
import MiniCartContainer from 'containers/MiniCart';
import MiniCart from 'components/Header/MiniCart'
import { useViewportMediaQuery } from 'hooks'
import FrequentProducts from './FrequentProducts';
import CMSFactory from 'factories/CMS';
//import WireTransferService from 'services/WireTransfer';
import style from './style.scss';//NOSONAR

let actions = [];

const HeaderContent = (props) => {
    const [isLogged, setLogged] = useState(false);
    const [firstName, setName] = useState('');
    const isMobile = useViewportMediaQuery(1121)

    const variant = useVariant(searchVariantID);
    const newVariant = variant === '1';

    const variantFrequentProduct = useVariant(frequentProductsID);
    const newVariantFrequentProduct = variantFrequentProduct === '1';

    useEffect(() => {
        actions.push(PubSub.register('logged_in', changeComponent));
        actions.push(PubSub.register('user_logout', changeComponent));
        actions.push(PubSub.register(actionsType.DRAWER.WELCOME_PRIME_OPEN, Logged));

        Logged();
        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = []
        }
    }, []);

    const changeComponent = (payload) => {
        if (payload.actionType === "logged_in"){
            setTimeout(() => Logged(), 500);
        }
        if (payload.actionType === "user_logout"){
            setLogged(false);
        }
    };

    const onClick = (action, tag) => {
        PubSub.dispatch('close_tracking');
        PubSub.dispatch('toggle_minicart', { state: false });
        PubSub.dispatch('toggle_menu', { state: false });
        PubSub.dispatch('toggle_preheader', { state: false })
        PubSub.dispatch(actionsType.DRAWER.MINICART_CLOSE)
        TagManagerService.clickHeader(action, tag);
    };

    const Logged = () => {
        const userData = StorageService.getSecureItem('userData');
        const isPrime =  userData.CencoPrime_2020 || userData.CencoPrime_CAT;
        setLogged(LoginService.isLogged());
        const drawerInvitation = StorageService.getItem('drawer_invitation');

        if(LoginService.isLogged() && drawerInvitation && !isPrime  && primeFlag && ((userData.countOrder === 3) || (userData.countOrder === null))){
            setTimeout(() => {
                _openDrawerPrime();
                StorageService.removeItem('drawer_invitation')
            }, 3000)
        }

        let name = userData.firstName;

        if(userData.email === 'pamela.ormeno@externos-cl.cencosud.com'){
            name = 'Muralla';
        } else if(userData.email === 'coloradomismael@gmail.com'){
            name = 'Patrón';
        } else if(userData.email === 'juliesozamcpherson@gmail.com'){
            name = 'Mom';
        } else if(userData.email === 'nicomasnovo@gmail.com'){
            name = 'Boludo';
        } else if(userData.email === 'comiramirez@gmail.com'){
            name = 'Conichi';
        }

        // if(features.statatusTransfer){
        //     validatePendingWiretransfer(userData);
        // }

        setName(name);
    };

    const openSearch = () => {
        PubSub.dispatch('open_search');
    }

    // const _open = (userInfo) => {
    //     PubSub.dispatch(actionsType.DRAWER.BANK_ACCOUNT_OPEN, {userInfo});
    // }

    // const validatePendingWiretransfer = (dataUser) => {
    //     if (!dataUser) return false;

    //     WireTransferService.statusWireTransfer().then(results => {
    //         if (results && results.length && results[0].status === "INIT") {
    //             setTimeout(() => {
    //                 PubSub.dispatch('open_snackbar', {
    //                     TitleMobile: 'Tienes una devolución pendiente por tu última compra. Para que realicemos el reembolso de tu dinero, ingresa una cuenta bancaria.',
    //                     TitleDesktop: 'Tienes una devolución pendiente por tu última compra. Para que realicemos el reembolso de tu dinero, ingresa una cuenta bancaria.',
    //                     titleButtonMobile: 'Agregar cuenta',
    //                     titleButtonDesktop: 'Agregar cuenta',
    //                     type: 'statusPendingWiretransfer',
    //                     className: 'snackbar-status-transfer-message',
    //                     callback: () => {
    //                         _open(dataUser?.user)
    //                     },
    //                 })
    //             }, 500)
    //         }
    //         return results
    //     });
    // }

    const _openDrawerPrime = () => {
        const userData = StorageService.getSecureItem('userData');
        const datePrime = CMSFactory.milliseconds(userData.prime_invitation_date) < CMSFactory.milliseconds(primeInvitation);
        if(!userData.prime_invitation_date || datePrime || userData.countOrder === 3) {
            PubSub.dispatch(actionsType.DRAWER.INVITATION_PRIME_OPEN);
        }
    }

    return <div className='new-header-wrapper'>
        <div className='new-header-container'>
            <Link onClick={() => onClick('Logo Jumbo', 'Header')} to="/" className={"new-header-logo-link " + header.logoEcommerce} aria-label="Jumbo Chile" />
            <Search />
            <div className='new-header-right-content'>
                {!isMobile && <DeliverySelector />}

                <div className={"new-header-wrap-links " + (isLogged ? ' position ' : '')}>
                    {!isLogged && <LoginRegister/>}
                    {isLogged && <UserMenu name={firstName} offers={props.offers}/>}
                </div>
                {newVariant && <button onClick={openSearch} className="search-icon-mobile-wrap"><i className="search-icon-variant jumbo-icon-new-search" /></button>}
                {isMobile && isLogged && !ecommerce.whiteLabel && newVariantFrequentProduct && <FrequentProducts />}
                {isMobile && isLogged && !ecommerce.whiteLabel && <Notifications />}
                <MiniCartContainer>
                    {(componentProps) => {
                        return <MiniCart {...componentProps}/>
                    }}
                </MiniCartContainer>
                
                
                <MobileMenu categories={props.categories} fixedCategories={props.fixedCategories} offers={props.offers}/>
            </div>
            
        </div>
    </div>;
};


HeaderContent.propTypes = {
    categories: PropTypes.array,
    fixedCategories: PropTypes.array
};

export default HeaderContent;
